import { cn } from '@/lib/utils'

export const getMessageActionButtonsClassName = ({
  prefersHover,
  isActive,
}: {
  prefersHover: boolean
  isActive: boolean
}) =>
  cn(
    'flex items-center gap-2 flex-shrink-0 transition-opacity duration-200',
    prefersHover
      ? 'opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto'
      : isActive
        ? 'opacity-100'
        : 'pointer-events-none w-0 gap-0 overflow-hidden opacity-0'
  )

export const shouldIgnoreMessageActivation = (target: EventTarget | null): boolean => {
  if (!(target instanceof Element)) {
    return true
  }

  return Boolean(
    target.closest(
      'a, button, video, input, textarea, [role="button"], [data-radix-collection-item], [data-reply-quote]'
    )
  )
}
